import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" }}>
      <div style={{ textAlign: 'center', maxWidth: 420 }}>
        <img src="/logo192.png" alt="AssessMonk" style={{ width: 52, height: 52, borderRadius: 14, objectFit: 'contain', marginBottom: 24 }} />
        <div style={{ fontSize: '4rem', fontWeight: 900, color: '#e2e8f0', lineHeight: 1, marginBottom: 8 }}>404</div>
        <h1 style={{ fontSize: '1.4rem', fontWeight: 800, color: '#0f172a', margin: '0 0 10px', letterSpacing: '-0.02em' }}>Page not found</h1>
        <p style={{ fontSize: '0.92rem', color: '#64748b', lineHeight: 1.7, margin: '0 0 28px' }}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          style={{ display: 'inline-block', padding: '11px 28px', background: '#4f46e5', color: '#fff', borderRadius: 10, fontWeight: 700, fontSize: '0.9rem', textDecoration: 'none' }}
        >
          Back to home
        </Link>
      </div>
    </div>
  );
}
